<template>
    <div>
        <v-dialog :md-active.sync="showAddDialog">
            <v-app>
                <v-form @submit.prevent="confirm">
                    <v-card class="window-card">
                        <v-card-title>
                            <span class="md-title" style="color: #67ad5b">新增工具元件动作</span>
                        </v-card-title>
                        <v-card-text>
                            <v-text-field v-model="form.name" label="动作名称 *" :rules="[v => !!v || '动作名称不能为空']"></v-text-field>
                            <v-select v-model="form.template" :items="template_list" item-text="name" item-value="value" label="动作模板*" :rules="[v => !!v || '动作模板不能为空']"></v-select>
                            <v-select v-model="form.moveModel" :items="moveModel_list" item-text="name" item-value="value" label="移动模式*" :rules="[v => !!v || '移动模式不能为空']" v-if="form.template === 'move'"></v-select>
                            <div class="md-layout" v-if="form.template === 'move'">
                                <div class="md-layout-item md-size-15" style="padding-top: 20px">
                                    <label class="md-form-label-ext"> 移动坐标 * </label>
                                </div>
                                <div class="md-layout-item md-size-30">
                                    <v-text-field v-model="form.movezbx" label="X" :rules="[v => !!v || '坐标X不能为空']"></v-text-field>
                                </div>
                                <div class="md-layout-item md-size-30">
                                    <v-text-field v-model="form.movezby" label="Y" :rules="[v => !!v || '坐标Y不能为空']"></v-text-field>
                                </div>
                                <div class="md-layout-item md-size-25">
                                    <v-text-field v-model="form.movezbz" label="Z" :rules="[v => !!v || '坐标Z不能为空']"></v-text-field>
                                </div>
                            </div>
                            <v-text-field v-model="form.moveTime" label="移动时间(秒) *" :rules="[v => !!v || '移动时间(秒)不能为空']" v-if="form.template === 'move'"></v-text-field>
                            <div class="md-layout" v-if="form.template === 'rotate'">
                                <div class="md-layout-item md-size-15" style="padding-top: 20px">
                                    <label class="md-form-label-ext"> 旋转坐标 * </label>
                                </div>
                                <div class="md-layout-item md-size-30">
                                    <v-text-field v-model="form.rotatex" label="X" :rules="[v => !!v || '坐标X不能为空']"></v-text-field>
                                </div>
                                <div class="md-layout-item md-size-30">
                                    <v-text-field v-model="form.rotatey" label="Y" :rules="[v => !!v || '坐标Y不能为空']"></v-text-field>
                                </div>
                                <div class="md-layout-item md-size-25">
                                    <v-text-field v-model="form.rotatez" label="Z" :rules="[v => !!v || '坐标Z不能为空']"></v-text-field>
                                </div>
                            </div>
                            <v-text-field v-model="form.rotateTime" label="旋转时间(秒) *" :rules="[v => !!v || '旋转时间(秒)不能为空']" v-if="form.template === 'rotate'"></v-text-field>
                            <v-text-field v-model="form.rotateTime" label="动画资源 *" :rules="[v => !!v || '动画资源不能为空']" v-if="form.template === 'animation'"></v-text-field>
                            <v-text-field v-model="form.animateSpeed" label="播放速率(帧/秒) *" :rules="[v => !!v || '播放速率(帧/秒)不能为空']" v-if="form.template === 'animation'"></v-text-field>
                            <md-field v-if="form.template === 'animation'">
                                <div class="md-layout">
                                    <div class="md-layout-item md-size-20">
                                        <label style="padding-top: 5px">是否倒播</label>
                                    </div>
                                    <div class="md-layout-item md-size-75">
                                        <v-switch v-model="form.replay"></v-switch>
                                    </div>
                                </div>
                            </md-field>
                            <v-radio-group v-model="form.type">
                                <v-radio label="动态参数：允许在任务中进行动态设置" value="dynamic"></v-radio>
                                <v-radio label="静态参数：固定在当前定义的动作内部" value="static"></v-radio>
                            </v-radio-group>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-button color="success" type="submit">确定</v-button>
                            <v-button color="success" @click="cancel">关闭</v-button>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-app>
        </v-dialog>
    </div>
</template>
<script>
import { SlideYDownTransition } from "vue2-transitions";
export default {
    props: {
        showAddDialog: {
            type: Boolean,
            default: false
        },
        index: {
            type: Number,
            default: -1
        },
        formData: {
            type: Object,
            default: () => {}
        }
    },
    components: {
        SlideYDownTransition,
    },
    watch: {
        formData(val) {
            this.form = val
        }
    },
    data() {
        return {
            lockview: '',
            moveModel_list: [
                { value: 'sy', name: '瞬移' },
                { value: 'py', name: '平移' },
                { value: 'xj', name: '寻径' }
            ],
            template_list: [
                { value: 'hide', name: '隐藏' },
                { value: 'display', name: '显示' },
                { value: 'move', name: '移动' },
                { value: 'rotate', name: '旋转' },
                { value: 'scale', name: '缩放' },
                { value: 'highlight', name: '高亮' },
                { value: 'dishighlight', name: '取消高亮' },
                { value: 'animation', name: '播放动画' }
            ],
            form: {
                movezbx: 0,
                movezby: 0,
                movezbz: 0,
                rotatex: 0,
                rotatey: 0,
                rotatez: 0,
                type: 'static'
            }
        }
    },
    methods: {
        confirm() {
            const time = new Date().getTime()
            if (this.index === -1 || !this.form.id) {
                this.form.id = `tool_${time}`
                this.form.create_time = time
            } else {
                this.form.update_time = time
            }
            this.$emit('handleConfirm', {
                form: this.form,
                index: this.index
            })
        },
        cancel() {
            this.$emit('handleCancel', {})
        }
    }
}
</script>
<style>
.window-card {
    box-shadow: 0 0px 0px 0 rgb(0 0 0 / 14%) !important;
}
</style>